import type { PageCard } from '@/play/pageTypes'
import { DripWallCardArt } from './CardArt'

/** What the home screen shows for this page; the page itself is ./index.ts, loaded when it opens. */
export const card: PageCard = {
  id: 'drip-wall',
  number: 30,
  title: 'Drip wall',
  question: 'Does goo that drips down a wall when you paint along its top feel gooey and alive?',
  status: 'open',
  accent: '#ffe0ef',
  CardArt: DripWallCardArt,
}
